import * as React from 'react';
import { cn, Textarea, Kbd } from '@ai-content-hub/content-kit';

export interface PromptTextareaProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    maxLength?: number;
    /** Slot rendered absolutely top-right inside the textarea wrapper (e.g. UploadButton) */
    uploadSlot?: React.ReactNode;
}

export const PromptTextarea: React.FC<PromptTextareaProps> = ({
    value,
    onChange,
    onKeyDown,
    placeholder = 'Enter your description...',
    disabled = false,
    maxLength = 500,
    uploadSlot,
}) => {
    const charCount = value.length;

    return (
        <>
            <div
                className="prompt-description-textarea-wrapper block w-full"
                style={{ position: 'relative' }}
            >
                <Textarea
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={cn('min-h-[120px] resize-y text-sm leading-relaxed w-full pb-8')}
                    style={{
                        paddingRight: uploadSlot && 20,
                        // paddingBottom: 24,
                    }}
                    rows={8}
                />
                {uploadSlot}
                {/* <span
                    className={cn(
                        'prompt-description-textarea-char-count pointer-events-none absolute right-3 z-[1] text-xs tabular-nums select-none',
                        charCount > maxLength * 0.9
                            ? 'text-destructive'
                            : 'text-muted-foreground/60'
                    )}
                    style={{ bottom: 4 }}
                    aria-hidden
                >
                    {charCount}/{maxLength}
                </span> */}
            </div>
        </>
    );
};
